import api from '../../services/api/companyMessageService';
import keyMirror from '../../utils/keyMirror';
import { omitProps } from '../../utils/utils';
import { APPLICATION_SUBSCRIPTION } from '../../constants';

export const actionTypes = keyMirror(
    {
        GET_COMPANY_DETAILS: null,
        GET_COMPANY_SUBSCRIPTIONS: null,
        UPDATE_COMPANY_PARAMS: null,
        RESET_COMPANY: null,
        GET_COMPANY_DETAILS_BY_ID: null,
        GET_COMPANY_USERS_BY_ID: null,
        CREATE_COMPANY: null,
        UPDATE_COMPANY: null,
        COMPANY_LOGO: null,
        DELETE_COMPANY: null,
        GET_COMPANY_LOGOS: null,
        RESET_LOGOS: null,
        GET_PICKLIST_BY_COMPANY_ID: null,
    },
    'Company'
);

// Action Creators

export const getCompany = (companyId = null) => dispatch => {
    if (companyId) {
        api.GetCompanyDataById(companyId).then(response => {
            const { data } = response;
            dispatch({
                type: actionTypes.GET_COMPANY_DETAILS,
                payload: [data],
            });
        });
    }
    else {
        api.GetCompanyData().then(response => {
            const { data } = response;
            dispatch({
                type: actionTypes.GET_COMPANY_DETAILS,
                payload: data,
            });
        });
    }
}

export const getCompanyById = (id, successHandler, errorHandler) => dispatch => {
    api.GetCompanyDataById(id).then(response => {
        const { data } = response;
        dispatch({
            type: actionTypes.GET_COMPANY_DETAILS_BY_ID,
            payload: data,
        });
        successHandler();
    }).catch(function (error) {
        errorHandler(error);
    });
}

export const getCompanySubscriptions = (id) => dispatch => {
    api.GetCompanySubscriptions(id).then(response => {
        const { data } = response;
        dispatch({
            type: actionTypes.GET_COMPANY_SUBSCRIPTIONS,
            payload: data,
        });
    });
}

export const getCompanyUsersById = (id) => dispatch => {
    api.GetCompanyUsersById(id).then(response => {
        const { data } = response;
        dispatch({
            type: actionTypes.GET_COMPANY_USERS_BY_ID,
            payload: data,
        });
    });
}

export const resetCompany = () => dispatch => {
    dispatch({
        type: actionTypes.RESET_COMPANY
    });
}
export const createCompany = (data, successHandler) => dispatch => {
    api.CreateCompanyData(data).then(() => {
        dispatch({
            type: actionTypes.CREATE_COMPANY
        });
        successHandler();
    });
}
export const updateCompany = (data, successHandler) => dispatch => {
    api.UpdateCompanyData(data).then(() => {
        dispatch({
            type: actionTypes.UPDATE_COMPANY,
            payload: data
        });
        successHandler();
    });
}
export const deleteCompany = (data) => dispatch => {
    api.UpdateCompanyStatus(data).then(() => {
        dispatch({
            type: actionTypes.DELETE_COMPANY,
            payload: data
        });
    });
}

export const getCompanyLogo = (id) => dispatch => {
    api.GetCompanyLogo(id).then((response) => {
        const { data } = response;
        dispatch({
            type: actionTypes.COMPANY_LOGO,
            payload: { id, data }
        });
    });
}

export const getCompanyLogoById = (id, successHandler, errorHandler) => dispatch => {
    api.GetCompanyLogo(id).then((response) => {
        const { data } = response;
        dispatch({
            type: actionTypes.UPDATE_COMPANY_PARAMS,
            payload: { key: 'fileURL', value: data }
        });
        successHandler();
    }).catch((error) => {
        errorHandler(error);
    });
}


export const updateCompanyParams = (data) => dispatch => {
    dispatch({
        type: actionTypes.UPDATE_COMPANY_PARAMS,
        payload: data,
    });
}

export const updateCompanySubscription = (data, successHandler, errorHandler) => dispatch => {
    api.UpdateCompanySubscription(data).then(() => {
        dispatch({
            type: actionTypes.UPDATE_COMPANY,
            payload: data
        });
        successHandler();
    })
        .catch((error) => {
            errorHandler(error);
        });
}

export const getCompanyLogos = (companyId, logo) => dispatch => {
    dispatch({
        type: actionTypes.GET_COMPANY_LOGOS,
        payload: { key: companyId, data: logo }
    });
}

export const resetLogos = (id = null) => dispatch => {
    dispatch({
        type: actionTypes.RESET_LOGOS,
        payload: id,
    });
}

export const getPickListByCompanyId = (id) => dispatch => {
    api.GetPickListByCompanyId(id).then(response => {
        const { data } = response;
        dispatch({
            type: actionTypes.GET_PICKLIST_BY_COMPANY_ID,
            payload: data,
        });
    });
}

// Reducer

export const initialState = {
    companies: null,
    company: {
        "id": -1,
        "name": '',
        "address": "",
        "city": "",
        "state": "",
        "postalCode": "",
        "contactFirstName": "",
        "contactLastName": "",
        "contactEmail": "",
        "contactPhone": "",
        "logo": '',
        "recordStatus": "O"
    },
    users: null,
    subscriptions: null,
    companyLogos: null,
};

export default function companyReducer(state = initialState, { type, payload }) {
    switch (type) {
        case actionTypes.GET_COMPANY_DETAILS:
            return {
                ...state,
                companies: [...payload],
            };
        case actionTypes.GET_COMPANY_DETAILS_BY_ID:
            return {
                ...state,
                company: { ...payload, contactPhone: payload.contactPhone, fileURL: '' },
            };
        case actionTypes.GET_COMPANY_SUBSCRIPTIONS: {
            const allSubscriptions = omitProps(payload, 'id');
            const subscribedSubscriptions = Object.keys(allSubscriptions).filter(sub => allSubscriptions[sub] === APPLICATION_SUBSCRIPTION.Subscribed);
            return {
                ...state,
                subscriptions: subscribedSubscriptions,
            }
        }
        case actionTypes.GET_COMPANY_USERS_BY_ID:
            return {
                ...state,
                users: [...payload],
            };
        case actionTypes.RESET_COMPANY:
            return {
                ...state,
                company: { ...initialState.company },
            };
        case actionTypes.UPDATE_COMPANY_PARAMS: {
            let obj = { ...state.company };
            obj[payload.key] = payload.value;
            return {
                ...state,
                company: { ...obj }
            };
        }
        case actionTypes.GET_COMPANY_LOGOS: {
            let logosCopy = { ...state.companyLogos };
            logosCopy[payload.key] = payload.data;
            return {
                ...state,
                companyLogos: { ...logosCopy },
            }
        }
        case actionTypes.RESET_LOGOS: {
            let updatedLogos = { ...initialState.companyLogos };
            if (payload) {
                delete updatedLogos[payload];
            }

            return {
                ...state,
                companyLogos: updatedLogos,
            }
        }
        case actionTypes.COMPANY_LOGO: {
            let companiesCopy = [...state.companies];
            const companyIndex = companiesCopy.findIndex(element => element.id === payload.id);
            companiesCopy[companyIndex] = { ...companiesCopy[companyIndex], fileURL: payload.data };
            return {
                ...state,
                companies: [...companiesCopy]
            };
        }
        case actionTypes.DELETE_COMPANY: {
            let companiesCopy = [...state.companies];
            const companyIndex = companiesCopy.findIndex(element => element.id === payload.id);
            companiesCopy.splice(companyIndex, 1);
            return {
                ...state,
                companies: [...companiesCopy]
            };
        }
        case actionTypes.UPDATE_COMPANY: {
            let companiesCopy = [...state.companies];
            const companyIndex = companiesCopy.findIndex(element => element.id === payload.id);
            companiesCopy[companyIndex] = {
                ...companiesCopy[companyIndex],
                ...payload
            };
            return {
                ...state,
                companies: [...companiesCopy]
            };
        }
        case actionTypes.GET_PICKLIST_BY_COMPANY_ID:
            return {
                ...state,
                pickList: [...payload],
            };

        default:
            return state;
    }
};
